import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Button, Modal, Textarea } from '@shared/widgets';

interface IForm {
  category: string;
}
const DEFAULT_VALUES = { category: '' };

interface Props {
  show: boolean;
  onClose: () => void;
  initialCategory?: string;
  onSave: (note: string) => Promise<void>;
}

export const AddCategoryModal = (props: Props) => {
  const { control, formState, handleSubmit, reset } = useForm<IForm>({ defaultValues: { ...DEFAULT_VALUES, category: props.initialCategory || '' } });
  const { t } = useTranslation('reports');

  const closeHandler = () => {
    props.onClose();
    reset({ ...DEFAULT_VALUES, category: props.initialCategory || '' });
  };
  const submitHandler = async (data: IForm) => await props.onSave(data.category);

  return (
    <Modal isOpen={props.show} onClose={closeHandler} title={t('card.transactions.modals.addCategory.title')}>
      <form className='flex flex-col gap-5' noValidate onSubmit={handleSubmit(submitHandler)}>
        <Controller
          name='category'
          control={control}
          render={({ field: { value, onChange } }) => (
            <Textarea
              fitContent
              placeholder={t('card.transactions.modals.addCategory.placeholders.enterMessage')}
              value={value}
              onChange={onChange}
            />
          )}
        />
        <Button fullWidth color='primary' type='submit' disabled={formState.isSubmitting}>
          {t('buttons.save', { ns: 'common' })}
        </Button>
      </form>
    </Modal>
  );
};
